import { capitalCase } from 'change-case';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Typography, Stack, Grid } from '@mui/material';
// components
import Image from '../../components/Image';
// sections
import { ChangePasswordForm } from '../../sections/auth/change-password';
import useLocales from '../../hooks/useLocales';
import { CardTitleAlt } from '../../layouts/GlobalStyles';

// ----------------------------------------------------------------------

const ContentStyle = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%'
}));

// ----------------------------------------------------------------------

export default function ChangePassword() {

  return (
    <ContentStyle spacing={4}>
      <ChangePasswordForm />
    </ContentStyle>
  );
}
